import { useEffect, useState } from "react";

export type NavPrefs = { order: string[]; hidden: string[] };

const key = (uid: string) => `abb-admin-nav:${uid}`;

// Menu layout is saved per user on this device.
export function useNavPrefs(userId: string | undefined) {
  const [prefs, setPrefs] = useState<NavPrefs>({ order: [], hidden: [] });

  useEffect(() => {
    if (!userId) return;
    try {
      const raw = localStorage.getItem(key(userId));
      if (raw) setPrefs(JSON.parse(raw));
    } catch { /* ignore */ }
  }, [userId]);

  const save = (p: NavPrefs) => {
    setPrefs(p);
    if (userId) localStorage.setItem(key(userId), JSON.stringify(p));
  };

  return { prefs, save, reset: () => save({ order: [], hidden: [] }) };
}

export function sortByOrder<T extends { id: string }>(items: T[], order: string[]) {
  const pos = (id: string) => { const i = order.indexOf(id); return i === -1 ? 999 : i; };
  return [...items].sort((a, b) => pos(a.id) - pos(b.id));
}
